<template>
  <div class="match-card match-card__daily-limit text-center">
    <div class="match-card__desc">
      <div class="title title--large title--white">
        {{ trans.get('pages:match_game.daily_limit.header') }}
      </div>
      <div class="desc desc--white my-1">
        {{ trans.get('pages:match_game.daily_limit.subheader') }}
      </div>
    </div>
    <div class="match-card__image">
      <i class="demo-icon icon-cards-daily" />
    </div>
    <div class="match-card__desc desc desc--white">
      {{ trans.get('pages:match_game.daily_limit.continue_tip') }}
      <router-link :to="{name: 'members'}" class="button button__outline button__outline--white-hov-purple">
        {{ trans.get('top_bar.members') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DailyLimitReachedCard',
  props: {
    current: Object,
  },
  data() {
    return {};
  },
  computed: {
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {},
  mounted() {

  }
};
</script>


